module.exports = {
    language: {
        name: '中文'
    },
    user: {
        login:'login',
        register:'register',
        loginUsername:'please input email or phone',
    },
    mainPage:{
        UWSEn:'University of the West of Scotland',
        UWSCn:'University of the West of Scotland',
        THU:'THU',
        schoolAddress:'68 Qianrong Road, Wuxi City, Jiangsu Province',
        telephone:'telephone：0510-85509888 | 85522008 | 8550399',
        phone:'phone：0510-85502763',
        fax:'fax：0510-85502663',
        tencent:'tencent',
    }
}


// WEBPACK FOOTER //
// ./src/components/work/language/en/en.js